<template>
  <transition name="bounce">
    <div class="typing-indicator">
      <span/>
      <span/>
      <span/>
    </div>
  </transition>
</template>

<script>
export default {
    name: 'Typing',
}
</script>



// WEBPACK FOOTER //
// src/components/Typing.vue